import { Component } from '@angular/core';

@Component({
	selector: 'abc-home-page',
	templateUrl: './abc-home-page.component.html',
	styleUrls: ['./abc-home-page.component.css']
})

export class AbcHomePageComponent {

	constructor() { }

}
